// extracted by mini-css-extract-plugin
module.exports = {"error-modal":"style_error-modal__3qFQo","error":"style_error__2o2SK","alert":"style_alert__2tIYF","success":"style_success__3mZ3U","text":"style_text__1fp-A"};